import classes from './StarRating.module.scss';

type StarRatingProps = {
  value: number;
  max?: number;
  size?: 'sm' | 'md';
  showValue?: boolean;
};

const renderStars = (max: number) =>
  Array.from({ length: max }).map((_, index) => (
    <span key={index} aria-hidden='true'>
      ★
    </span>
  ));

export const StarRating = ({
  value,
  max = 5,
  size = 'md',
  showValue = false,
}: StarRatingProps) => {
  const safe = Math.max(0, Math.min(max, Number(value) || 0));
  const fillPercent = max > 0 ? (safe / max) * 100 : 0;

  return (
    <span
      className={`${classes.stars} ${classes[`stars--${size}`]}`}
      aria-label={`Рейтинг ${safe.toFixed(1)} из ${max}`}
    >
      <span className={classes.stars__track}>
        <span className={classes.stars__empty}>{renderStars(max)}</span>
        <span className={classes.stars__fill} style={{ width: `${fillPercent}%` }}>
          {renderStars(max)}
        </span>
      </span>
      {showValue ? <strong className={classes.stars__value}>{safe.toFixed(1)}</strong> : null}
    </span>
  );
};
